import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { config } from "../config";
import { status } from "../_constants";
import { useDispatch, useSelector } from "react-redux";
import { HomeActions } from "../_actions/homeContent.action";
import foodhygiene from "../assets/images/food-hygiene.svg";
import foodhygiene1 from "../assets/images/food-hygiene1.png";
import foodhygiene2 from "../assets/images/food-hygiene2.png";
import foodhygiene3 from "../assets/images/food-hygiene3.png";
import foodhygiene4 from "../assets/images/food-hygiene4.png";



const HomeFooter = () => {
    const dispatch = useDispatch();
    const home = useSelector((state) => state.home);
    const [homeData, sethomeData] = useState();
    const [loading, setLoading] = useState(true);
    const [configData, setConfigData] = useState(
        JSON.parse(localStorage.getItem("configData"))
    );

    const preloadImages = (imageUrls) => {
        return imageUrls.map((url) => {
            const img = new Image();
            img.src = url;
            if (img.onload) {

            } else {
                setTimeout(() => { }, 1000);
            }
        });
    };
    // useEffect(() => {
    //     if (!home?.homeContent_data) {
    //         dispatch(HomeActions.loadHomeData());
    //     }
    // }, []);

    useEffect(() => {
        if (home && home?.homeContent_status == status?.SUCCESS) {
            sethomeData(home?.homeContent_data);
            setLoading(false);
            localStorage.setItem("home", JSON.stringify(home?.homeContent_data));
            const imageUrls = [
                `${config.localApiUrl}/tenancy/assets/${home?.homeContent_data?.banners[0]?.banner}`,
                `${config.localApiUrl}/tenancy/assets/${home?.homeContent_data?.banners[1]?.banner}`,
            ];
            preloadImages(imageUrls);
        }
    }, [home?.homeContent_data]);
    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //         setLoading(false);
    //     }, 1000);
    //     return () => clearTimeout(timer);
    // }, []);
    return (
        <div className="home-footer home-footer-2 mt-5">
            <div className="container">
                <div className="row-nowrap">
                    <div className="content nth-child-1">
                        {loading ? (
                            <Skeleton
                                width={"100%"}
                                height={30}
                                baseColor="#4f4e4e"
                                highlightColor="#eeeeee33"
                                borderRadius={20}
                                style={{ marginTop: 70 }}
                            />
                        ) : (
                            <img
                                src={
                                    configData &&
                                    `${config.localApiUrl}/tenancy/assets/${configData?.footerLogo}`
                                }
                                alt=""
                                className="logo-footer"
                            />
                        )}
                    </div>

                    <div className="content">
                        <h3>
                            {loading ? (
                                <Skeleton
                                    width={"100%"}
                                    height={25}
                                    baseColor="#4f4e4e"
                                    highlightColor="#eeeeee33"
                                    borderRadius={20}
                                />
                            ) : (
                                "Location"
                            )}
                        </h3>
                        {loading ? (
                            <Skeleton
                                width={"100%"}
                                height={18}
                                baseColor="#4f4e4e"
                                highlightColor="#eeeeee33"
                                borderRadius={20}
                            />
                        ) : (
                            <p>{homeData && homeData?.locationData?.addressLine1}</p>
                        )}
                        {loading ? (
                            <Skeleton
                                width={"100%"}
                                height={18}
                                baseColor="#4f4e4e"
                                highlightColor="#eeeeee33"
                                borderRadius={20}
                            />
                        ) : (
                            <p>{homeData && homeData?.locationData?.addressLine2}</p>
                        )}
                        {loading ? (
                            <Skeleton
                                width={"100%"}
                                height={45}
                                baseColor="#4f4e4e"
                                highlightColor="#eeeeee33"
                                borderRadius={30}
                                style={{ marginTop: 20 }}
                            />
                        ) : (
                            <div className="get-btn">
                                <a
                                    href={homeData && homeData?.locationData?.directionLink}
                                    target="_blank"
                                >
                                    <div className="location-icon" />
                                    <span>Get Directions</span>
                                </a>
                            </div>
                        )}
                    </div>

                    <div className="content">
                        <h3>
                            {loading ? (
                                <Skeleton
                                    width={"100%"}
                                    height={25}
                                    baseColor="#4f4e4e"
                                    highlightColor="#eeeeee33"
                                    borderRadius={20}
                                />
                            ) : (
                                "Opening hours"
                            )}
                        </h3>

                        <div className="opening">
                            {homeData &&
                                homeData?.openingHoursData &&
                                homeData?.openingHoursData?.Weekly?.split(";").map((line, index) => {
                                    if (!line.trim()) return null;

                                    const [dayPart, timePart] = line.split("|");

                                    return (
                                        <div className="time" key={index}>
                                            {loading ? (
                                                <Skeleton
                                                    width={"182px"}
                                                    height={18}
                                                    baseColor="#4f4e4e"
                                                    highlightColor="#eeeeee33"
                                                    borderRadius={20}
                                                />
                                            ) : (
                                                <>
                                                    <p>{dayPart?.trim()}</p>
                                                    <span>{timePart?.trim()}</span>
                                                </>
                                            )}
                                        </div>
                                    );
                                })}
                        </div>
                    </div>


                    <div className="content nth-child">
                        <h3>
                            {loading ? (
                                <Skeleton
                                    width={"182px"}
                                    height={25}
                                    baseColor="#4f4e4e"
                                    highlightColor="#eeeeee33"
                                    borderRadius={20}
                                />
                            ) : (
                                "Get In Touch"
                            )}
                        </h3>
                        <ul>
                            <li>
                                {loading ? (
                                    <Skeleton
                                        width={"182px"}
                                        height={18}
                                        baseColor="#4f4e4e"
                                        highlightColor="#eeeeee33"
                                        borderRadius={20}
                                    />
                                ) : (
                                    <a
                                        href={`tel:${homeData && homeData?.getintouchData?.contactNumber
                                            }`}
                                    >
                                        <div className="phone-icon" />
                                        {homeData && homeData?.getintouchData?.contactNumber}
                                    </a>
                                )}
                            </li>
                            <li>
                                {loading ? (
                                    <Skeleton
                                        width={"182px"}
                                        height={18}
                                        baseColor="#4f4e4e"
                                        highlightColor="#eeeeee33"
                                        borderRadius={20}
                                    />
                                ) : (
                                    <a href="/">
                                        <div className="website-icon" />
                                        {window.location.hostname}
                                    </a>
                                )}
                            </li>
                            <li>
                                {loading ? (
                                    <Skeleton
                                        width={"182px"}
                                        height={18}
                                        baseColor="#4f4e4e"
                                        highlightColor="#eeeeee33"
                                        borderRadius={20}
                                    />
                                ) : (
                                    <a
                                        href={`mailto:${homeData && homeData?.getintouchData?.supportEmail
                                            }`}
                                    >
                                        <div className="email-icon" />
                                        {homeData && homeData?.getintouchData?.supportEmail}
                                    </a>
                                )}
                            </li>
                        </ul>
                    </div>

                    <div className="content">
                        <div className="footer-icon">
                            <ul>
                                {homeData &&
                                    homeData.socialsData.tiktokUrl &&
                                    homeData.socialsData.tiktokUrl != "null" && (
                                        <li>
                                            {loading ? (
                                                <Skeleton
                                                    width={30}
                                                    height={30}
                                                    baseColor="#4f4e4e"
                                                    highlightColor="#eeeeee33"
                                                    borderRadius={50}
                                                />
                                            ) : (
                                                <a href={homeData.socialsData.tiktokUrl}>
                                                    <div className="tiktok-icon" />
                                                </a>
                                            )}
                                        </li>
                                    )}
                                {homeData &&
                                    homeData.socialsData.instagramUrl &&
                                    homeData.socialsData.instagramUrl != "null" && (
                                        <li>
                                            {loading ? (
                                                <Skeleton
                                                    width={30}
                                                    height={30}
                                                    baseColor="#4f4e4e"
                                                    highlightColor="#eeeeee33"
                                                    borderRadius={50}
                                                />
                                            ) : (
                                                <a href={homeData.socialsData.instagramUrl}>
                                                    <div className="insta-icon" />
                                                </a>
                                            )}
                                        </li>
                                    )}
                                {homeData &&
                                    homeData.socialsData.facebookUrl &&
                                    homeData.socialsData.facebookUrl != "null" && (
                                        <li>
                                            {loading ? (
                                                <Skeleton
                                                    width={30}
                                                    height={30}
                                                    baseColor="#4f4e4e"
                                                    highlightColor="#eeeeee33"
                                                    borderRadius={50}
                                                />
                                            ) : (
                                                <a href={homeData.socialsData.facebookUrl}>
                                                    <div className="fb-icon" />
                                                </a>
                                            )}
                                        </li>
                                    )}

                                {homeData &&
                                    homeData.socialsData.snapchatUrl &&
                                    homeData.socialsData.snapchatUrl != "null" && (
                                        <li>
                                            {loading ? (
                                                <Skeleton
                                                    width={30}
                                                    height={30}
                                                    baseColor="#4f4e4e"
                                                    highlightColor="#eeeeee33"
                                                    borderRadius={50}
                                                />
                                            ) : (
                                                <a href={homeData.socialsData.snapchatUrl}>
                                                    <div className="snap-icon" />
                                                </a>
                                            )}
                                        </li>
                                    )}
                            </ul>
                        </div>
                        {/* <div className="foodhygiene">
                            {loading ? (
                                <Skeleton
                                    width={"100%"}
                                    height={100}
                                    baseColor="#4f4e4e"
                                    highlightColor="#eeeeee33"
                                    borderRadius={10}
                                />
                            ) : configData?.starRating ? (
                                <img src={foodhygiene1} alt="" />
                            ) : null}
                            {loading ? (
                                <Skeleton
                                    width={"100%"}
                                    height={100}
                                    baseColor="#4f4e4e"
                                    highlightColor="#eeeeee33"
                                    borderRadius={10}
                                />
                            ) : configData?.starRating ? (
                                <img src={foodhygiene2} alt="" />
                            ) : null}
                            {loading ? (
                                <Skeleton
                                    width={"100%"}
                                    height={100}
                                    baseColor="#4f4e4e"
                                    highlightColor="#eeeeee33"
                                    borderRadius={10}
                                />
                            ) : configData?.starRating ? (
                                <img src={foodhygiene3} alt="" />
                            ) : null}
                            {loading ? (
                                <Skeleton
                                    width={"100%"}
                                    height={100}
                                    baseColor="#4f4e4e"
                                    highlightColor="#eeeeee33"
                                    borderRadius={10}
                                />
                            ) : configData?.starRating ? (
                                <img src={foodhygiene4} alt="" />
                            ) : null}
                            {loading ? (
                                <Skeleton
                                    width={"100%"}
                                    height={100}
                                    baseColor="#4f4e4e"
                                    highlightColor="#eeeeee33"
                                    borderRadius={10}
                                />
                            ) : configData?.starRating ? (
                                <img src={foodhygiene} alt="" />
                            ) : null}
                        </div> */}

                        <div className="foodhygiene">
                            {loading ? (
                                <Skeleton
                                    width={"100%"}
                                    height={100}
                                    baseColor="#4f4e4e"
                                    highlightColor="#eeeeee33"
                                    borderRadius={10}
                                />
                            ) : homeData?.foodHygieneData?.enabled && (
                                <img
                                    src={
                                        homeData.foodHygieneData.foodHygieneRating === "1" ? foodhygiene1 :
                                            homeData.foodHygieneData.foodHygieneRating === "2" ? foodhygiene2 :
                                                homeData.foodHygieneData.foodHygieneRating === "3" ? foodhygiene3 :
                                                    homeData.foodHygieneData.foodHygieneRating === "4" ? foodhygiene4 :
                                                        foodhygiene
                                    }
                                    alt={`Hygiene Rating ${homeData.foodHygieneData.foodHygieneRating}`}
                                />
                            )}

                        </div>



                        {/* <div className="foodhygiene">
                            {homeData?.foodHygieneData?.enabled && (
                                <>
                                    {<img
                                        src={
                                            homeData.foodHygieneData.foodHygieneRating === "1" ? foodhygiene1 :
                                                homeData.foodHygieneData.foodHygieneRating === "2" ? foodhygiene2 :
                                                    homeData.foodHygieneData.foodHygieneRating === "3" ? foodhygiene3 :
                                                        homeData.foodHygieneData.foodHygieneRating === "4" ? foodhygiene4 :
                                                            foodhygiene
                                        }
                                        alt={`Hygiene Rating ${homeData.foodHygieneData.foodHygieneRating}`}
                                    />}
                                </>
                            )}

                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeFooter;